import React, { useState } from 'react';
import styles from './ItemCard.module.scss';
import Button from 'component/atom/forms/button/Button';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import ConfirmationModal from 'component/hoc/success-modal/ConfirmationModal';
import Tooltip from 'component/Custom/tooltip/Tooltip';

const ItemCard = ({
  item,
  handleDelete,
  isPendingDelete,
  deleteTitle,
  deleteSubText,
  handleEditClick,
  viewText,
  viewClick,
  nameKey,
}) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  return (
    <div className={styles['form-card']}>
      <div className={styles['form-header']}>
        <span className={styles['form-name']}>{item?.[nameKey]}</span>
        <span className={styles['form-title']}>{item?.formTitle}</span>
      </div>
      <div className={styles['form-footer']}>
        <Button
          onClick={() => viewClick(item.id)}
          label={viewText}
          opicBackground={true}
          className={styles['view-responses-btn']}
          variant="light"
        />
        <div className={styles['action-btns']}>
          <Tooltip content="Edit">
            <SvgWithBranding
              className={styles['pen-icon']}
              color="#535353"
              type="edit"
              onClick={() => handleEditClick(item.id)}
            />
          </Tooltip>
          <Tooltip content="Delete" red={true}>
            <SvgWithBranding
              className={styles['delete-icon']}
              color="#535353"
              type="delete2"
              onClick={() => {
                setIsDeleteModalOpen(true);
              }}
            />
          </Tooltip>
        </div>
      </div>
      <ConfirmationModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onSubmit={() => handleDelete(item)}
        closeOnSubmit={true}
        onApproveButton={{ text: 'delete' }}
        text={deleteTitle}
        subText={deleteSubText}
        isLoading={isPendingDelete}
        subTextClassName={styles.modalSubText}
        modalContentClassName={styles.modalContentClassName}
        buttonClassName={styles.buttonClassName}
        closeBtnContainerClassName={styles.closeBtnContainer}
        closeBtnClassName={styles.closeBtn}
      />
    </div>
  );
};

export default ItemCard;
